document.addEventListener("DOMContentLoaded", () => {
  const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;

  function setupSpeculationRules() {
    const nsProducts = Array.from(document.querySelectorAll(".ns-product")).filter((product) => {
      const link = product.querySelector(".ns-details > a");
      return link && !link.href.includes("/collections/brands");
    });

    if (!nsProducts.length) return false;

    if (!HTMLScriptElement.supports || !HTMLScriptElement.supports("speculationrules")) return true;

    if (isTouchDevice) {
      const href_matches = nsProducts.slice(0, 12).map((product) => {
        const link = product.querySelector(".ns-details > a");
        return { href_matches: link.href };
      });

      const specScript = document.createElement("script");
      specScript.type = "speculationrules";
      specScript.textContent = JSON.stringify({
        prerender: [
          {
            source: "document",
            where: { or: href_matches },
            eagerness: "eager",
          },
        ],
      });
      document.head.appendChild(specScript);
    } else {
      nsProducts.forEach((product) => {
        product.addEventListener("mouseenter", () => {
          const link = product.querySelector(".ns-details > a");
          if (!link || !link.href) return;

          const specScript = document.createElement("script");
          specScript.type = "speculationrules";
          specScript.textContent = JSON.stringify({
            prerender: [
              {
                source: "document",
                where: { href_matches: link.href },
                eagerness: "eager",
              },
            ],
          });
          document.head.appendChild(specScript);
        });
      });
    }

    return true;
  }

  if (!setupSpeculationRules()) {
    const observerTarget = document.querySelector("#ns-product-grid") || document.body;
    const observer = new MutationObserver(() => {
      if (setupSpeculationRules()) observer.disconnect();
    });
    observer.observe(observerTarget, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 10000);
  }
});
